import { render } from "./OutStorageRecordDetailOriginal.vue?vue&type=template&id=7b9d9587&scoped=true"
import script from "./OutStorageRecordDetailOriginal.vue?vue&type=script&lang=js"
export * from "./OutStorageRecordDetailOriginal.vue?vue&type=script&lang=js"

import "./OutStorageRecordDetailOriginal.vue?vue&type=style&index=0&id=7b9d9587&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b9d9587"]])

export default __exports__